import { useState } from 'react';

export const useCarouselNavigation = (initialPageIndex: number) => {
  const [currentPageIndex, setCurrentPageIndex] = useState(initialPageIndex);
  const [slideDirection, setSlideDirection] = useState<'right' | 'left'>('left');

  const handlePageNavigation = (direction: 'next' | 'prev') => {
    setSlideDirection(direction === 'next' ? 'left' : 'right');
    setCurrentPageIndex(prevPageIndex =>
      direction === 'next'
        ? prevPageIndex + 1
        : prevPageIndex - 1,
    );
  };

  return { currentPageIndex, slideDirection, handlePageNavigation };
};
